import { useMemo } from "react";
import { useLinkedTravelerState } from "./linkedTravelerStore";
import { WireLoyaltyLink, deriveWireLoyaltyLink } from "../services/mockLoyalty";

/**
 * Mabuhay Miles display state for the PA demo (MOVMO-541, reworked
 * MOVMO-567). WIRE-AUTHORITATIVE: `link`/`sessionActive` are derived
 * entirely from the `loyalty` claim group on the traveler's latest
 * GET /me response (useLinkedTraveler → useLinkedTravelerState), never from the on-site
 * LoyaltyLinkModal ceremony or the loyalty-in-consent OAuth-redirect
 * params — those are transition theater only (see services/mockLoyalty.ts's
 * file-header comment). A traveler who runs the ceremony but hasn't
 * actually granted `loyalty.read` to PA in Movmo will see the confirmation
 * toast but NOT the member chip — that's the truthful behavior Brian
 * asked for (never present fixture data as if it came from Movmo).
 *
 * No separate flicker-avoidance cache is kept: `traveler` (and its
 * `.loyalty`) already lives in sessionStorage via useLinkedTravelerState and
 * persists across page navigations within the session, so there is no
 * async gap to paper over here beyond the /me round trip itself,
 * which the header already renders as "anonymous" today.
 */
export function useLoyaltySession() {
    const { traveler } = useLinkedTravelerState("pa");
    const link: WireLoyaltyLink | null = useMemo(
        () => deriveWireLoyaltyLink(traveler?.loyalty),
        [traveler],
    );

    return {
        link,
        traveler,
        sessionActive: link !== null,
    };
}
